import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => ({
  section: {
    padding: theme.spacing(4, 0),
  },
  title: {
    marginBottom: theme.spacing(4),
  },
  inputCode: {
    maxWidth: 640,
    width:'100%',
  },
}))

export default useStyles
